// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"105":"46fd671b","248":"f236a69e"}[chunkId] + ".chunk.css";
};